import { Component, OnInit, Inject, ViewContainerRef } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
export interface ModalSamllData {
  type: string;
  result?: string;
  btnAccept?: string;
  btnCancel?: string;
  list?: any[];
  columns?: any;
  text?: string;
  modalconfirm?: boolean;
}
@Component({
  standalone: false,
  selector: 'app-modal-small',
  templateUrl: './modal-small.component.html',
  styleUrls: ['./modal-small.component.scss'],
})
export class ModalSmallComponent implements OnInit {
  constructor(
    viewContainerRef: ViewContainerRef,
    @Inject(MAT_DIALOG_DATA) public data: ModalSamllData
  ) { }

  ngOnInit() {
    this.data = Object.assign({ modalconfirm: false, btnAccept: 'Continuar', btnCancel: 'Cancel' }, this.data);
  }
}
